import {courseService} from '@jobseeker/common-core/services';
import {Card, Image} from '@jobseeker/lotus/components';
import {cleanUrl} from '@jobseeker/lotus/utils';
import {CardActionArea, CardContent} from '@mui/material';
import {Box, Button, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {Course} from './types';
import {openCourseDetailPage} from './utils';
import {openUrl} from '@jobseeker/common-core/utils/common';

type AllCategoriesCourses = {
  id: number;
  name: string;
  data: Course[];
}[];

const BrowseAllCategories = () => {
  const [allCategoriesCourses, setAllCategoriesCourses] =
    useState<AllCategoriesCourses>([]);
  const [categoryIndex, setCategoryIndex] = useState(0);

  useEffect(() => {
    courseService
      .getAllCategoriesCourses()
      .then((data: {category: AllCategoriesCourses}) =>
        setAllCategoriesCourses(
          data.category.filter(category => category.data.length > 0).slice(0, 5)
        )
      );
  }, []);

  if (allCategoriesCourses.length === 0) {
    return null;
  }

  return (
    <Box textAlign="center" mt={10}>
      <Typography
        fontSize={20}
        fontWeight={600}
        sx={{
          textDecoration: 'underline #f59f4b',
        }}
        mb={3}
      >
        BROWSE ALL CATEGORIES
      </Typography>

      <Box mb={3}>
        {allCategoriesCourses.map((category, idx) => (
          <Button
            key={idx}
            variant="text"
            onClick={() => setCategoryIndex(idx)}
            disableFocusRipple
            disableRipple
            disableTouchRipple
            sx={{
              ':hover': {
                bgcolor: 'transparent',
              },
            }}
          >
            <Typography
              color="rgb(33, 33, 33)"
              fontWeight={categoryIndex === idx ? 600 : 400}
              sx={{
                textDecoration: categoryIndex === idx ? 'underline' : 'none',
              }}
            >
              {category.name}
            </Typography>
          </Button>
        ))}
      </Box>

      <Box
        display="flex"
        flexWrap="wrap"
        maxWidth={1300}
        ml="auto"
        mr="auto"
        justifyContent="center"
        gap={3}
        mb={7}
      >
        {allCategoriesCourses[categoryIndex].data.map((course, i) => (
          <Card
            variant="raised"
            heading=""
            key={i}
            sx={{
              cursor: 'pointer',
              p: 0,
              width: 322,
              textAlign: 'left',
              borderRadius: '2px',
              border: '1px solid #efeeee',
              boxShadow: '0 0 3px 0 rgba(0,0,0,0.2)',
            }}
          >
            <CardActionArea
              sx={{
                p: 2,
              }}
              onClick={() =>
                openCourseDetailPage(course.title, course.id, {
                  refinv: 'lhome',
                  reforg: `category_${allCategoriesCourses[categoryIndex].id}`,
                })
              }
            >
              <CardContent sx={{p: 0}}>
                <Box sx={{height: 180}}>
                  <Image
                    src={course.campusImage}
                    alt={course.institute}
                    style={{
                      width: '100%',
                      height: '100%',
                      maxHeight: '180px',
                      borderRadius: '5%',
                    }}
                  />
                  <Image
                    src={course.logo}
                    alt={course.institute}
                    width={75}
                    height={75}
                    style={{
                      position: 'absolute',
                      top: 25,
                      left: 25,
                      borderRadius: '10%',
                    }}
                  />
                </Box>
                <Typography height={72}>{course.title}</Typography>
                <Typography fontWeight={600} mt={2}>
                  {course.institute}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
      <Button
        variant="outlined"
        onClick={() =>
          openUrl(
            `${process.env.NEXT_PUBLIC_LOAD_CONFIG}/learning/course/${cleanUrl(
              allCategoriesCourses[categoryIndex].name
            )}-${allCategoriesCourses[categoryIndex].id}`
          )
        }
        sx={{
          fontSize: 16,
          ':hover': {
            bgcolor: 'transparent',
          },
        }}
        disableFocusRipple
        disableRipple
        disableTouchRipple
      >
        View All
      </Button>
    </Box>
  );
};

export default BrowseAllCategories;
